<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
     商品分组
      <small>/&nbsp;<router-link to="/grouporderlist" style="color:#6a7786">分组列表</router-link>/&nbsp;分组报价</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">报价分组列表</h4>
              </div>
              <!-- end panel-heading -->
               <!-- begin panel-body -->
              <div class="panel-body">
              <form

                style="margin-top:16px;padding-left:15px;"
              >
                <fieldset>
                  <div class="form-group row m-b-15">

                  <label class="col-md-1 col-form-label">品牌名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="BrandList"
                          key-field="brandId"
                          show-field="brandName"
                          placeholder="品牌名称"
                          v-model="brandId"
                          @values="BrandChanges"
                          title=""
                        ></v-selectpage>
                      </div>
                      <label class="col-md-1 col-form-label">系列名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="SeriesList"
                          key-field="seriesId"
                          show-field="seriesName"
                          placeholder="系列名称"
                          v-model="seriesId"
                          title=""
                        ></v-selectpage>
                      </div>

                  <label class="col-md-1 col-form-label">商品查询</label>
                      <div class="col-md-2">
                           <input
                        type="text"
                        class="form-control"
                        placeholder="商品编号/商品名称"
                        v-model="fuzzy"
                      >
                        <!-- <v-selectpage
                          :data="GoodsList"
                          key-field="goodsId"
                          show-field="goodsName"
                          placeholder="商品编号/商品名称"
                          v-model="goodsId"
                        ></v-selectpage> -->
                      </div>
                    <div class="col-md-1">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="SearchClick()"
                        style="float:right;"
                      >查询</a>
                    </div>
                    <div class="col-md-2"></div>
                    <div class="col-md-11"></div>
                    <div class="col-md-1">
                      <a
                        class="btn btn-primary ButtonColor"
                        @click="AddClick()"
                        style="float:right;"
                      >新增</a>
                    </div>
                  </div>
                   <div class="form-group row m-b-15"></div>
                </fieldset>
              </form>

                <el-table :data="PackManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号"  width="60" align="center"></el-table-column>
                  <el-table-column prop="groupName" label="分组名称" align="center"></el-table-column>
                  <el-table-column prop="brandName" label="品牌名称" align="center"></el-table-column>
                  <el-table-column prop="seriesName" label="系列名称" align="center"></el-table-column>
                  <el-table-column prop="goodsCode" label="商品编号" align="center"></el-table-column>
                  <el-table-column prop="goodsName" label="商品名称"  header-align="center" show-overflow-tooltip></el-table-column>

                  <el-table-column prop="packageRates" label="包装率" align="center" width="120"></el-table-column>
                   <el-table-column label="建议零售价" align="center" width="150">
                      <template slot-scope="scope">
                        <div style="width:100%;" @click="EditPrice(scope.row)">{{scope.row.advicePrice}}<span style="cursor:pointer;color:#348fe2;font-weight:700;">[查看]</span></div>
                      </template>
                   </el-table-column>
                   <el-table-column label="分销价" align="center" width="150">
                      <template slot-scope="scope">
                        <div style="width:100%;" @click="EditPrice(scope.row)">{{scope.row.recomPrice}}<span style="cursor:pointer;color:#348fe2;font-weight:700;">[查看]</span></div>
                      </template>
                   </el-table-column>
                   <el-table-column label="门店价" align="center" width="150">
                      <template slot-scope="scope">
                        <div style="width:100%;" @click="EditPrice(scope.row)">{{scope.row.shopPrice}}<span style="cursor:pointer;color:#348fe2;font-weight:700;">[查看]</span></div>
                      </template>
                   </el-table-column>
                  <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                      <a
                        class="btn btn-primary btn-sm ButtonColor"

                        @click="EditClick(scope.row)"
                      >编辑</a>

                       <!-- <a
                        class="btn btn-primary btn-sm ButtonColor"

                        @click="SettingClick(scope.row)"
                      >设置报价</a> -->
                      <a
                        class="btn btn-primary btn-sm ButtonColor"

                        @click="DetailClick(scope.row)"
                      >详情</a>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"

                        @click="DeleteClick(scope.row)"
                      >删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
                </div>
                     <div style="height: 64px;padding-top:8px;margin-right: 8px;">
                       <a  class="btn btn-primary m-r-5 BackButton" @click="Goback">返&nbsp;&nbsp;回</a>

                        <span class="clear"></span>
                  </div>

              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px">

      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled="disabled">确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>

        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
        <el-form-item label="分组名称:" prop="groupId"  v-if="DialogTitle === '新增'||DialogTitle === '编辑'" >
            <el-select v-model="ruleForm.groupId" clearable placeholder="请选择" style="width:100%" class="DistributorMargin" :disabled="groupdisabled">
            <el-option
              v-for="item in GroupList"
              :key="item.groupId"
              :label="item.groupName"
              :value="item.groupId">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="品牌名称:" prop="brandId" v-if="DialogTitle === '新增'||DialogTitle === '编辑'">
            <el-select v-model="ruleForm.brandId"  placeholder="请选择" style="width:100%" class="DistributorMargin"
             @change="BrandChange" :disabled="DialogTitle === '编辑'" filterable>
            <el-option
              v-for="item in brandList"
              :key="item.brandId"
              :label="item.brandName"
              :value="item.brandId">
            </el-option>
          </el-select>
          </el-form-item>
           <el-form-item label="系列名称:" prop="seriesId" v-if="DialogTitle === '新增'||DialogTitle === '编辑'">
            <el-select v-model="ruleForm.seriesId"  placeholder="请选择" style="width:100%" class="DistributorMargin"
              @change="SeriesChange" :disabled="DialogTitle === '编辑'" filterable>
            <el-option
              v-for="item in seriesList"
              :key="item.seriesId"
              :label="item.seriesName"
              :value="item.seriesId">
            </el-option>
          </el-select>
          </el-form-item>
           <el-form-item label="商品名称:" prop="goodsId"  v-if="DialogTitle === '新增'||DialogTitle === '编辑'">
            <el-select v-model="ruleForm.goodsId"  placeholder="请选择" style="width:100%" class="DistributorMargin" :disabled="DialogTitle === '编辑'">
            <el-option
              v-for="item in GoodsLists"
              :key="item.goodsId"
              :label="item.goodsName"
              :value="item.goodsId">
            </el-option>
          </el-select>
          </el-form-item>

          <el-form-item label="包装率:" prop="packageRates"  v-if="DialogTitle === '新增'||DialogTitle === '编辑'">
            <el-input v-model.number="ruleForm.packageRates" class="DistributorMargin"></el-input>
          </el-form-item>
         <el-form-item label="零售价格:" prop="advicePrice" >
            <el-input v-model="ruleForm.advicePrice" class="DistributorMargin"></el-input>
          </el-form-item>
         <el-form-item label="分销价:" prop="recomPrice" >
            <el-input v-model="ruleForm.recomPrice" class="DistributorMargin"></el-input>
          </el-form-item>
         <el-form-item label="门店价:" prop="shopPrice" >
            <el-input v-model="ruleForm.shopPrice" class="DistributorMargin"></el-input>
          </el-form-item>

            <el-form-item label="供货价:" prop="quotedPrice" v-if="DialogTitle === '新增'||DialogTitle === '编辑'">
            <el-input v-model="ruleForm.quotedPrice"  class="DistributorMargin"></el-input>
          </el-form-item>


          <el-form-item label="是否包邮:" prop="isFee" v-if="DialogTitle === '新增'||DialogTitle === '编辑'">
            <el-select v-model="ruleForm.isFee" clearable placeholder="请选择"  style="width:100%"  class="DistributorMargin" @change="isFeeChange">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="运费:" prop="expressFee" v-if="(DialogTitle === '新增'||DialogTitle === '编辑')&&expressFreeShow" >
            <el-input v-model="ruleForm.expressFee"  class="DistributorMargin"></el-input>
          </el-form-item>

        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "PackManagement",
  data() {
    var checkpackagerates = (rule, value, callback) => {
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (value <= 0) {
            callback(new Error("必须大于0"));
          } else if(value > 99){
              callback(new Error("必须小于100"));
          }else{
            callback();
          }
        }
      }, 1000);
    };
    var checkadvicePrice = (rule, value, callback) => {

      setTimeout(() => {
        let reg=/^\d+(\.\d{1,2})?$/;
        if (!reg.test(value)) {
          callback(new Error("大于0且不能超过两位小数"));
        } else if(value < 0){
          callback(new Error("大于0且不能超过两位小数"));
         }else{
          callback();
        }
      }, 1000);
    };
    var checkquotedPrice = (rule, value, callback) => {

      setTimeout(() => {
        let reg=/^\d+(\.\d{1,2})?$/;
        if (value && !reg.test(value)) {
          callback(new Error("报价大于0且不能超过两位小数"));
        } else if (value && value == 0){
          callback(new Error("报价大于0"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      DialogTitle: "编辑",
      EditDialog: 1,
      CurrentSelection: [],
      BrandOptions:[],
      options:[],
      GoodsList:[],
      brandList:[],
      GoodsLists:[],
      goodsId:'',
      brandId:'',
      seriesId:'',
      BrandList:[],
      SeriesList:[],
      seriesList:[],
      value4:'',
      groupId:'',
      disabled:false,
      groupdisabled: true,
      expressFreeShow: false,
      fuzzy: "",
      status: "1",
      options: [
        {
          label: "是",
          value: 0
        },
        {
          label: "否",
          value: 1
        }
      ],
      StateOptions: [
        {
          label: "删除",
          value: 0
        },
        {
          label: "正常",
          value: 1
        }
      ],
      ruleForm: {

      },
      rules: {
        groupId: [
          { required: true, message: "请选择分组名称", trigger: "blur" }
        ],
         brandId: [
          { required: true, message: "请选择品牌名称", trigger: "blur" }
        ],
        seriesId: [
          { required: true, message: "请选择系列名称", trigger: "blur" }
        ],
        goodsId: [
          { required: true, message: "请选择商品名称", trigger: "blur" }
        ],

        packageRates: [
          { required: true, message: "请输入包装率", trigger: "blur" },
          { validator: checkpackagerates, trigger: "blur" }
        ],
        advicePrice: [
          { required: true, message: "请输入零售价", trigger: "blur" },
          { validator: checkadvicePrice, trigger: "blur" }
        ],
        recomPrice: [
          { required: true, message: "请输入分销价", trigger: "blur" },
          { validator: checkadvicePrice, trigger: "blur" }
        ],
        shopPrice: [
          { required: true, message: "请输入门店价", trigger: "blur" },
          { validator: checkadvicePrice, trigger: "blur" }
        ],
        isFee: [
          { required: true, message: "请选择是否包邮", trigger: "blur" }
        ],
        expressFee:[
            { required: true, message: "请输入运费", trigger: "blur" },
             { validator: checkadvicePrice, trigger: "blur" }
        ],
        quotedPrice:[
           { required: false,validator: checkquotedPrice, trigger: "blur" }
        ]


      },
      GroupList:[],
      UserManagementEdit: "",
      TimeValue: "",
      PackManagementList: [],
      currentPage: 1,
      firstSearchContent:'',
      firstpageSize:10,
      firstpageIndex:1
    };
  },
  mounted: function() {

      if (JSON.stringify(this.$route.params) !== "{}") {
      this.brandId = JSON.parse(this.$route.params.searchContent).brandId;
      this.seriesId = JSON.parse(this.$route.params.searchContent).seriesId;
     this.fuzzy = JSON.parse(this.$route.params.searchContent).fuzzy;

    }

       if(this.$route.query){
          this.firstSearchContent = JSON.parse(this.$route.query.firstSearchContent);
          this.firstpageSize = this.$route.query.firstpageSize;
          this.firstpageIndex = this.$route.query.firstpageIndex;

        }

     if(this.$route.query.groupId){
               this.groupId = this.$route.query.groupId;

            }
    this.initdata();
    this.getGroupList();
    this.getGoodsList();
    this.getBrandInfo();
    this.InitBrandInfo();
  },
  watch:{
    pageNo: {
    　　handler(newName, oldName) {
            if(this.$route.params){
               this.pageNo = this.$route.params.pageNo
            }

       　　},
    　　immediate: true
    },
   pagesize:{
      　handler(newName, oldName) {

            if(JSON.stringify(this.$route.params) !== "{}"){
               this.pageSize = this.$route.params.pagesize;

            }

       　　},
    　　immediate: true
    }
  },
  computed: {
      pageNo:{
        set(val){
          if(val){

             this.pageindex = val
          }

        },
        get(){
       //   console.log('我被调用了') //msg1获取值时触发

        }
      },
      pagesize:{
        set(val){
          if(val){
             this.pageSize = val
          }

        },
        get(){
          //console.log('我被调用了') //msg1获取值时触发

        }
      }
 },
  methods: {
      InitBrandInfo() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.BrandList = response.data.data.brandList;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    Goback(){
      this.$router.push({ name: "GroupOrderList",
       params: { pageNo : this.firstpageIndex , pagesize:this.firstpageSize,firstSearchContent: JSON.stringify(this.firstSearchContent)}
       });
    },
    EditPrice(row){
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }
      this.outerVisible = true;
      this.DialogTitle = "修改零售价";
      this.EditDialog = 1;
       this.ruleForm = MethodsBus.cloneRow(row);
    },
    isFeeChange(val){

      if(val === 0){
        this.expressFreeShow = false;

      }else if(val === 1){
       this.expressFreeShow = true;

      }

    },
      BrandChanges(val) {

      if(val.length !== 0){
          let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          brandId: that.brandId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.SeriesList = response.data.data;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
      }else{
        this.brandId = '';
        this.seriesId = "";
        this.SeriesList = [];
      }

    },

     getBrandInfo(){
      let that = this;
      const options = {
        url: "distribution/B2cGoodsBrandController/queryBrandIdAndName",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          brandId: that.ruleForm.brandId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.brandList = response.data.data;
          } else {
             http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });

    },
    getGroupList(){
          let that = this;


      const options = {
        url: "distribution/B2cGoodsPackageRates/queryGroupList",
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({


        })
      };
      axios(options).then(function(response) {

        if (response.data.code == 200) {


         that.GroupList = response.data.data;
        } else {
           http.handleEorrorCode(response,that);
        }
      });
    },
    BrandChange(val){
       let that = this;


      const options = {
        url:"distribution/B2cGoodsInfoController/cascadeQuery",

        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({

         brandId: val
        })
      };
      axios(options).then(function(response) {

        if (response.data.code == 200) {


         that.seriesList = response.data.data;
         that.ruleForm.seriesId = "";
         if(that.ruleForm.goodsId){
            that.ruleForm.goodsId = '';
         }
         that.BrandChangeSecond(val);
        } else {
            http.handleEorrorCode(response,that);
        }
      });

    },
    BrandChangeSecond(val){

      let that = this;
      if(!that.ruleForm.brandId && !that.ruleForm.seriesId ){
         const secondoptions = {
           url:"distribution/B2cGoodsInfoController/getB2cGoodsList",

            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({

               brandId: val,
               seriesId: that.ruleForm.seriesId
           })
      };
      axios(secondoptions).then(function(response) {

        if (response.data.code == 200) {
          that.GoodsLists = response.data.data;


        } else {
            http.handleEorrorCode(response,that);
        }
      });
      }
    },
    SeriesChange(){
      let that = this;

      if(that.ruleForm.brandId !== '' && that.ruleForm.seriesId !== '' && that.ruleForm.brandId !== undefined  && that.ruleForm.seriesId !== undefined && that.ruleForm.brandId !== null  && that.ruleForm.seriesId !== null){
         const options = {
           url:"distribution/B2cGoodsInfoController/getB2cGoodsList",

            method: "post",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            data: Qs.stringify({

               brandId: that.ruleForm.brandId,
               seriesId: that.ruleForm.seriesId
           })
      };
      axios(options).then(function(response) {

        if (response.data.code == 200) {


         that.GoodsLists = response.data.data;
          if(that.ruleForm.goodsId){
            that.ruleForm.goodsId = '';
         }
        } else {
            http.handleEorrorCode(response,that);
        }
      });
      }
    },
    singleValues(){
     this.getGoodsList();
    },
    getGoodsList(){
   let that = this;


      const options = {
        url: "distribution/B2cGoodsPackageRates/queryGoodsList",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({

         groupId: that.groupId
        })
      };
      axios(options).then(function(response) {

        if (response.data.code == 200) {


         that.GoodsList = response.data.data;
        } else {
           http.handleEorrorCode(response,that);
        }
      })
       .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },

    EditClick(row) {
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }
      if(row.isFee === 1){
        this.expressFreeShow = true;
      }else{
         this.expressFreeShow = false;
      }
      this.CurrentSelection = row;
      this.ruleForm = MethodsBus.cloneRow(row);


      this.ruleForm.goodsId = row.goodsName;
      this.ruleForm.seriesId = row.seriesName;
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    SettingClick(row){
      let searchContent = {};
      searchContent.brandId = this.brandId;
      searchContent.fuzzy = this.fuzzy;
      searchContent.seriesId = this.seriesId;
      this.$router.push({ path: "/packprice" });
      localStorage.setItem("goodlists", JSON.stringify({row:row,pageNo:this.pageindex,pageSize:this.pageSize,searchContent:JSON.stringify(searchContent)}));
    },
    DetailClick(row){
      let searchContent = {};
      searchContent.brandId = this.brandId;
      searchContent.fuzzy = this.fuzzy;
      searchContent.seriesId = this.seriesId;
      this.$router.push({ path: "/packdetail",query:{ firstSearchContent: JSON.stringify(this.firstSearchContent),
         firstpageIndex: this.firstpageIndex,firstpageSize: this.firstpageSize,searchContent:JSON.stringify(searchContent)}});
      localStorage.setItem("goodlists", JSON.stringify({row:row,pageNo:this.pageindex,pageSize:this.pageSize}));
    },
    AddClick() {
      this.ruleForm = {};
       this.ruleForm.groupId = this.$route.query.groupId;
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.expressFreeShow = false;
      this.GoodsLists = [];
      this.seriesList = [];
      this.EditDialog = 1;
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },

    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "修改零售价") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cGoodsPackageRates/updateAdivePrice",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                groupId: that.ruleForm.groupId,
                goodsId: that.ruleForm.goodsId,
                packageRates: that.ruleForm.packageRates,
                advicePrice: that.ruleForm.advicePrice,
                recomPrice: that.ruleForm.recomPrice,
                shopPrice: that.ruleForm.shopPrice,
              })
            };
            axios(options).then(function(response) {
              that.outerVisible = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });
              } else {
                 http.handleEorrorCode(response,that);
              }
            })
             .catch(function(error) {
          http.handleHttpError(error, that);
        });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
             that.disabled = true;
            const options = {
              url: "distribution/B2cGoodsPackageRates/addPackagerates",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                groupId: that.ruleForm.groupId,
                goodsId: that.ruleForm.goodsId,

                packagerates: that.ruleForm.packageRates,
                advicePrice: that.ruleForm.advicePrice,
                recomPrice: that.ruleForm.recomPrice,
                shopPrice: that.ruleForm.shopPrice,

                quotedPrice: that.ruleForm.quotedPrice,
                isFee: that.ruleForm.isFee,
                expressFee: that.ruleForm.expressFee,
              })
            };
            axios(options).then(function(response) {
              that.outerVisible = false;
               that.disabled = false;
              if (response.data.code == 200) {
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: "新增成功",
                  type: "success"
                });
              } else {
                 http.handleEorrorCode(response,that);
              }
            })
             .catch(function(error) {
          http.handleHttpError(error, that);
        });
          } else {
            this.outerVisible = true;
          }
        });
      }else if(this.DialogTitle === "编辑"){
              that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            if(that.ruleForm.isFee === 0){
              that.ruleForm.expressFee = 0;
            }
            const options = {
              url: "distribution/B2cGoodsPackageRates/updatePackagerates",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                groupId: that.ruleForm.groupId,
                brandId: that.CurrentSelection.brandId,
                seriesId: that.CurrentSelection.seriesId,
                packageratesId: that.CurrentSelection.packageratesId,
                packagerates: that.ruleForm.packageRates,
                advicePrice: that.ruleForm.advicePrice,
                recomPrice: that.ruleForm.recomPrice,
                shopPrice: that.ruleForm.shopPrice,
                goodsId: that.CurrentSelection.goodsId,
                quotedPriceId: that.ruleForm.quotedPriceId,
                quotedPrice: that.ruleForm.quotedPrice,
                isFee: that.ruleForm.isFee,
                expressFee: that.ruleForm.expressFee,

              })
            };
            axios(options).then(function(response) {
              that.outerVisible = false;
              that.disabled = false;
              if (response.data.code == 200) {
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: response.data.message,
                  type: "success"
                });
              } else {
                 http.handleEorrorCode(response,that);
              }
            })
             .catch(function(error) {
          http.handleHttpError(error, that);
        });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
        const options = {
        url: "distribution/B2cGoodsPackageRates/deletePackagerates",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({


          groupId: that.CurrentSelection.groupId,
          goodsId: that.CurrentSelection.goodsId,
          packagerates: that.CurrentSelection.packageRates,
          packageratesId: that.CurrentSelection.packageratesId
        })
      };
      axios(options).then(function(response) {
        that.outerVisible = false;
          that.disabled = false;
        if (response.data.code == 200) {
             that.initdata();
             that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch(function(error) {
           that.outerVisible = false;
          that.disabled = false;
          http.handleHttpError(error, that);
        });

    },

    initdata() {
     let that = this;
      const options = {
        url: "distribution/B2cGoodsPackageRates/queryPackageratesList",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({

          fuzzy: that.fuzzy,
          seriesId: that.seriesId,
          brandId: that.brandId,
          groupId: that.groupId,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.totalCount = response.data.data.totalCount;
          for (var i in response.data.data.data) {
            response.data.data.data[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;


          }

          that.PackManagementList = response.data.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.BackButton{
  color:#fff !important;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/GroupManage/PackManagement.vue